/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-01-08 19:25:09
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'

import BsyFilterBase from '../BsyFilterBase';
import './index.css'
import BsySelect from '../../BsySelect';
import { BsyUtils } from '../../../utils/Utils';
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterEntry extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            ...props
        })

        this.dashText = null;
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.EQ]
    }

    getValue = () => {
        if (this.dashText) {
            return this.dashText.getValue()

        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    componentDidMount() {
        super.componentDidMount()
        this._loadEntry();
    }

    _loadEntry = () => {
        let that = this;

        if (that.options.appId) {
            React.axios(`/dashboard/app/${that.options.appId}/workflow/query_menu`, {
                appId: that.options.appId,
                entryId: this.options.flowType,
                popupFormPath: [],
                type: this.options.flowType,
            }).then(res => {
                BsyUtils.showAjaxTip(res.data, () => {

                    var i = [];

                    BsyUtils.forEach(res.data.data, function (t, a) {
                        i.push({
                            value: a.entryId,
                            text: a.name,
                        })
                    })
                    this.setState({
                        items: [...i]
                    })
                })

            }).catch(res => {
                console.error(res);
            })
        }
    }


    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue() || {};

        return <BsySelect
            theme={this.props.theme}
            hasLimit={!0}
            allowBlank={true}
            onBeforeAsync={i.onBeforeAsync}
            items={this.state.items}
            value={val}
            height={'34px'}
            onStopEdit={e1 => {
                e.value = e.getValue()
                BsyUtils.applyFunc(e, i.onStopEdit, [{
                    value: e.getValue(),
                    valueMode: e.valueMode,
                    method: e.method,
                }, i], !1)
            }}
            getContext={this.getContext}
        />

    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

